@if (contactId > 0) {
<section class="sticky-toolbar rounded">
    <div class="card">
        <div title="Show Alerts & Notes">
            <notes [module]="'collections,contacts'" [saleId]="saleId" [contactId]="contactId"
                [key]="'past-due'" (posted)="notePosted($event)" title="Show Alerts & Notes"></notes>
        </div>
    </div>
</section>
}

<div class="content">

    <div class="container-fluid">

        <div class="card-deck">

            <div class="card">
                <div class="card-body">
                    <h2 class="card-title clickable" (click)="edit($event)">{{contactName}}</h2>
                    <p class="card-subtitle text-muted">{{address}}</p>
                    <div class="card-subtitle">
                        @if (phone) {
                        <a href="tel://{{phone}}" class="card-link">{{formattedPhone}}</a>
                        }
                        @if (email) {
                        <a href="mailto:{{email}}" class="card-link">{{email}}</a>
                        }
                    </div>
                    <div class="link-bar">
                        <a href="#" class="card-link" (click)="edit($event)"><span class="material-icons">edit</span></a>
                    </div>
                </div>
            </div>

            <div class="card due d-none d-xl-block" (click)="payPastDue($event)">
                <div class="card-body">
                    <span class="material-icons" [class.text-danger]="pastDue > 0">fmd_bad</span>
                    <div>
                        <h2 class="card-title" [class.text-danger]="pastDue > 0">{{pastDue | currency}}</h2>
                        <p class="card-subtitle text-muted">Past due amount {{pastDueSince}}.</p>
                        <p class="card-subtitle">{{pastDueCategories}}</p>
                    </div>
                    @if (pastDue > 0) {
                    <button class="btn btn-danger btn-sm">pay</button>
                    }
                </div>
            </div>
        </div>

        <div class="card-deck d-block d-xl-none">

            <div class="card due" (click)="payPastDue($event)">
                <div class="card-body">
                    <span class="material-icons" [class.text-danger]="pastDue > 0">fmd_bad</span>
                    <div>
                        <h2 class="card-title" [class.text-danger]="pastDue > 0">{{pastDue | currency}}</h2>
                        <p class="card-subtitle text-muted">Past due amount {{pastDueSince}}.</p>
                    </div>
                    @if (pastDue > 0) {
                    <button class="btn btn-danger btn-sm">pay</button>
                    }
                </div>
            </div>

        </div>

        <div class="card-columns">

            <take-payment [contactId]="contactId" [language]="language" [pays]="pays" [allocate]="allocation"
                [payThisAmount]="payThisAmountEvent" (paymentTaken)="paymentTaken($event)"></take-payment>

            <associations [contactId]="contactId"></associations>

            <gps-devices [saleId]="saleId"></gps-devices>

            <div class="card" id="past-due-detail">
                <div class="card-body">
                    <h2 class="card-title">Account Information</h2>
                </div>
                <div class="card-body">
                    <ul class="nav nav-tabs">
                        @for (group of groupKeys; track group; let i = $index) {
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="i === 0" [id]="group + '-tab'" data-toggle="tab" [attr.data-target]="'#group' + group" role="tab">
                                @if (!groups[group].url) {
                                <span class="material-icons">{{icon(groups[group].category)}}</span>
                                }
                                @if (groups[group].url) {
                                <img [src]="groups[group].url" [alt]="groups[group].vehicle || null" />
                                }
                            </a>
                        </li>
                        }
                    </ul>

                    <div class="tab-content">
                        @for (group of groupKeys; track group; let j = $index) {
                        <div class="tab-pane fade" [class.show]="j === 0" [class.active]="j === 0" role="tabpanel"
                            [attr.aria-labelledby]="group + '-tab-pane'" [id]="'group' + group">
                            <div class="card">
                                <div class="card-header">
                                    <div class="header-title-bar">
                                        <div>
                                            <p class="card-title">{{groups[group].title}}</p>
                                            <p class="card-subtitle text-muted">{{groups[group].subtitle}}</p>
                                        </div>
                                    </div>
                                    @if (groups[group].quote) {
                                    <div class="badge-bar">
                                        <a class="alert alert-warning quote-status"
                                            [routerLink]="['/quotes/', groups[group].saleId]">Sale Stage is
                                            <strong>Quote</strong>
                                        </a>
                                    </div>
                                    }
                                    @else {
                                    <div class="badge-bar">
                                        @if (groups[group].financed) {
                                            <div class="alert alert-{{insuranceClass(groups[group])}}"
                                                [routerLink]="['/sales', groups[group].saleId, 'insurance']">
                                                {{insuranceMessage(groups[group])}}
                                            </div>
                                        }
                                        @if (security.permitted('collections', 'take payment', 'update')) {
                                            <div class="alert alert-secondary edit-payments" [routerLink]="['/terms/', groups[group].termsId, 'payments']">
                                                <span class="material-icons">edit</span>
                                                <span>Edit sale payments</span>
                                            </div>
                                        }
                                    </div>
                                    }
                                    @if (groups[group].financed) {
                                    <ul class="terms">
                                        <li>{{groups[group].method}}</li>
                                        <li>
                                            <span>{{groups[group].quote ? 'Quoted' : 'Sold'}}</span>
                                            <span class="numeric">{{groups[group].sold | date:'E MMM d, yyyy'}}</span>
                                        </li>
                                        <li>
                                            <span>{{groups[group].frequency}} Payment Amount</span>
                                            <span class="numeric">{{groups[group].payment | currency }}</span>
                                        </li>
                                        @if (!groups[group].quote) {
                                        <li>
                                            <span>Riding Cash</span>
                                            <span class="numeric">{{groups[group].ridingCash | currency }}</span>
                                        </li>
                                        }
                                        <li>
                                            <span>Principal Balance</span>
                                            <span class="numeric">{{groups[group].balance | currency }}</span>
                                        </li>
                                    </ul>
                                    }
                                    @else {
                                    <ul class="terms">
                                        <li>{{groups[group].type}}</li>
                                        <li>
                                            <span>Sold</span>
                                            <span class="numeric">{{groups[group].sold | date:'E MMM d, yyyy'}}</span>
                                        </li>
                                    </ul>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>

            <pay-promises [saleId]="saleId" [language]="language" [pays]="pays" [paymentTaken]="paymentTakenEvent"
                [key]="'pdv'" (promised)="promiseAdded($event)"></pay-promises>

            <receipts [key]="'pdv'" [saleId]="saleId" [paymentTaken]="paymentTakenEvent" [language]="language"></receipts>

        </div>

    </div>
</div>

<contact-modal [contactId]="contact ? contact.id : 0" [key]="'past-due'" [language]="language" [words]="words" (modified)="contactModified($event)"></contact-modal>